<template>
<div>
  <modal-cadu close :width="600" v-model="show">
    <div slot="all" class="pt-10 pb-4 px-10">
      <div slot="header">
        <div
          class="font-secundaria headline font-weight-bold pb-4"
          style="color: #00995D"
        >ADICIONAR TOKEN DE APLICAÇÃO</div>
      </div>
      <div slot="body">
        <ValidationObserver ref="observer">
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-row>
                <v-col cols="12" sm="12" md="11">
                  <validation-provider
                    name="apelido"
                    ref="apelido"
                    mode="eager"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <input-cadu
                      title="Nome da aplicação"
                      v-model="nomeAplicacao"
                      :errorMessage="errors[0]"
                      max="70"
                    />
                  </validation-provider>
                </v-col>
                <v-col cols="12" sm="12" md="11">
                  <datepicker-cadu
                    :menuOpen="showDatePicker"
                    :inputTitle="'Data de Expiração'"
                    :inputValue="dataExpiracao"
                    :minDate="today"
                    typeCalendar="date"
                    validateProviderRules="dateValidatorForFuture|required"
                    @value="value => dataExpiracao= value"
                    width="280"
                  ></datepicker-cadu>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </ValidationObserver>
      </div>
      <div slot="footer" class="pt-6">
        <v-row>
          <v-col>
            <v-row justify="start">
              <v-col cols="auto">
                <button-cadu outline @click="$emit('input', false)">VOLTAR</button-cadu>
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <v-row justify="end">
              <v-col cols="auto">
                <button-cadu @click="finalizar">SALVAR</button-cadu>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
  </modal-cadu>

  <overlay-loading v-model="loadingOverlay"/>
  <error-modal v-model="error" :errObj="errObj" />
</div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import moment from 'moment'

import GerenciamentoToken from '../../../../../services/GerenciamentoToken/GerenciamentoToken'

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: this.value,
      nomeAplicacao: '',
      tokenBearer: localStorage.getItem('tokenBearer'),
      today: moment().add(1, 'day').format('DD/MM/YYYY'),
      login: '',

      // DatePicker
      showDatePicker: false,
      dataExpiracao: '',

      loadingOverlay: false,

      // Erro
      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      }
    }
  },
  methods: {
    async finalizar () {
      const res = await this.$refs.observer.validate()
      if (res) {
        const dados = {
          nome: this.nomeAplicacao,
          dataExpiracao: this.dataExpiracao
        }
        await this.postAdicionarNovaAplicacao(dados)
        // this.$emit("finalizar", dados);
      }
    },
    limparCampos () {
      this.nomeAplicacao = ''
      this.dataExpiracao = ''
    },
    async postAdicionarNovaAplicacao (objeto) {
      this.loadingOverlay = true
      let gerenciamento = new GerenciamentoToken(
        this.tokenBearer,
        this.$appConfig.config.API
      )

      try {
        let response = await gerenciamento.postTokenAplicacao(objeto)
        this.show = false
        this.loadingOverlay = false
        this.$emit('finalizar', response.data.token)
      } catch (err) {
        this.loadingOverlay = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    }
  },
  watch: {
    value () {
      this.show = this.value
    },
    show () {
      if (!this.show) {
        this.limparCampos()
      }
      this.$emit('input', this.show)
    }
  }
}
</script>

<style>
</style>
